/**
 * Player UI snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_PlayerUI
 * @extends Snippet
 */

Snippet_PlayerUI = (function(Snippet) {

	var Snippet_PlayerUI = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_PlayerUI.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;
			this.movie = null;
			
			this.uiTimeout = 10000;  // ms
			this.uiTimer = null;     // timer
			this.isVisibleUI = false;
			this.Qmenu = Main.getDevice()[ 0 ] === 'lg';  // boolean
			
			// Player Movie Info snippet (Pause info)
			this.playerMovieInfoSnip = new Snippet_PlayerMovieInfo(this, {});
			this.playerMovieInfoSnip.on("focus:out", this.onFocusOut, this);
			
			// Player Progress Bar snippet
			this.playerProgressBarSnip = new Snippet_PlayerProgressBar(this, {});
			this.playerProgressBarSnip.on("focus:out", this.onFocusOut, this);
			
			// Player Controls snippet
			this.playerControlsSnip = new Snippet_PlayerControls(this, {});
			this.playerControlsSnip.on("focus:out", this.onFocusOut, this);

			// // Player Subtitle snippet
			// this.playerSubtitlesSnip = new Snippet_SubtitlesMenu(this, {});
			this.playerSubtitlesSnip = new Snippet_SubtitlesMenu(this, {});
			this.playerSubtitlesSnip.on("focus:out", this.onFocusOut, this);

			Focus.on( 'focus', this.onAppFocus, this );
		},
		
		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-player-ui");
			}
		},
		
		/**
		 * @inheritdoc Snippet#render
		 * @param {Object} movie (Asset Model)
		 */
		render: function(movie) {
			this.movie = movie || this.movie || {};
			this.clear();

			this.playerSubtitlesSnip.render({ subtitles: this.movie.subtitles, subtitlesUrl: this.movie.subtitles_url});
			this.playerMovieInfoSnip.render(this.movie);
			this.playerProgressBarSnip.render();
			this.playerControlsSnip.render(this.movie);
		},
		
		/**
		 * To show Player UI
		 */
		showPlayerUI: function() {
			var scope = this;			
			var showMovieInfo = Player.currentState === Player.STATE_PAUSED ? true : false;
			var isFastSeeking = this.playerControlsSnip.currentSpeed === 1 ? false : true; 
			showMovieInfo = isFastSeeking ? false : showMovieInfo;

			$('#subtitles-wrap').addClass('goUp');

			if(!this.isVisiblePlayerUI()) {
				// this.playerProgressBarSnip.show();
				this.playerControlsSnip.show();
				this.isVisibleUI = true;
				this.parent.focus();
			}
			
			if(showMovieInfo && !this.playerMovieInfoSnip.isVisible) {
				this.playerMovieInfoSnip.show();
			} else if(!showMovieInfo && this.playerMovieInfoSnip.isVisible) {
				this.playerMovieInfoSnip.hide();
			}
			
			clearTimeout( this.uiTimer );
			this.uiTimer = setTimeout( function() {
				if ( isFastSeeking || scope.playerMovieInfoSnip.isVisible ) {
					scope.showPlayerUI(); // keep to checking
				} else {
					scope.hidePlayerUI();
				}
			}, this.uiTimeout );
		},
		
		hidePlayerUI: function() {
			clearTimeout(this.uiTimer);

			$('#subtitles-wrap').removeClass('goUp');

			this.playerSubtitlesSnip.hide();
			this.playerSubtitlesSnip.isVisible = false;

			// this.playerProgressBarSnip.hide();
			this.playerProgressBarSnip.hideScrubber(true);
			this.playerControlsSnip.hide();
			this.isVisibleUI = false;
		},
		
		isVisiblePlayerUI: function() {
			return this.isVisibleUI;
		},

		showQMenu: function() {
			Device.qmenu();
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {

			var action = $el.attr('data-action');

			switch (action) {
				case 'qmenu':
					scope.showQMenu();
					break;
			}

			return false;
		},
		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction) {
			if (direction === "up") {
				if(!this.$scrubber.hasClass("active")) {
					this.$scrubber.addClass("active");
				}
				this.trigger("focus:out", this, direction);
			}
			else if (direction === "down") {
				this.trigger("focus:out", this, direction);
			}
			else if (direction === "left") {
				if(!this.playerSubtitlesSnip.isVisible) {
					Focus.to(this.getCircleFocusable(-1));
				}
			}
			else if (direction === "right") {
				if(!this.playerSubtitlesSnip.isVisible) {
					Focus.to(this.getCircleFocusable(+1));
				}
			}

			return false;
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function() {
			return this.playerControlsSnip.focus();
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function($el) {
			this.$lastFocused = $el;
		},

		/**
		 * Handling focus on other snippet by mouse
		 * @param  {jQuery object} $el focused element
		 */
		onAppFocus: function( $el ) {
			if ( !this.parent.isVisible ) {
				return;
			}

			// if ( this.playerSubtitlesSnip.isVisible && !Focus.isIn( this.playerControlsSnip.$btnLanguage ) && !this.playerSubtitlesSnip.hasFocus() ) {
			// 	this.playerSubtitlesSnip.hide();
			// } else if ( this.playerProgressBarSnip.isVisibleScrubber && !this.playerProgressBarSnip.hasFocus() ) {
			// 	this.playerProgressBarSnip.hideScrubber();
			// }

			/*if ( this.hasFocus() ) {
				this.$el.addClass( 'focused' );
			} else {
				this.$el.removeClass( 'focused' );
			}*/
		},
		
		clear: function(deep) {
			this.$lastFocused = null;
			
			clearTimeout(this.uiTimer);
			if(deep) {
				this.playerProgressBarSnip.clear();
				this.playerControlsSnip.clear();
				this.playerMovieInfoSnip.clear();
			}
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function( snippet, direction ) {
			switch ( snippet ) {

				case this.playerControlsSnip:
				 	if(direction === 'up') {
						this.playerProgressBarSnip.showScrubber();
						this.playerProgressBarSnip.focus();
					}
					break;
				
				case this.playerProgressBarSnip:
					switch ( direction ) {
					
						case 'left':
							return this.playerControlsSnip.focus( this.playerControlsSnip.$btnFf );
							break;

						case 'right':
							if (!(this.movie.subtitles && this.movie.subtitles.length)) {  // subtitle button disabled
								return this.playerControlsSnip.focus( this.Qmenu ? this.playerControlsSnip.$btnQmenu : this.playerControlsSnip.$btnPlay );
							} else {
								return this.playerControlsSnip.focus( this.playerControlsSnip.$btnLanguage );
							}
							break;

						case 'up':
						case 'down':
						default:
							break;
					}
					break;

				case this.playerSubtitlesSnip:
					switch ( direction ) {
						case 'up':
							break;
						case 'down':
							this.playerSubtitlesSnip.hide();
							return this.playerControlsSnip.focus( this.playerControlsSnip.$btnLanguage );
							break;

						default:
							break;
					}
					break;

				default:
					break;
			}
		}

	});

	return Snippet_PlayerUI;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/player_ui.js
// module id = 74
// module chunks = 0